<template>
    <div>
        <title-component></title-component>
        <b-form>
            <div class="row">
                <div class="col-12 col-sm-12">
                    <card-title-component :title="$t('photos.title')"></card-title-component>
                    <div class="card-content">
                        <div class="row">
                            <div class="col">
                                <input id="photoInput" ref="photoInput" type="file" style="visibility:hidden"
                                       accept="image/*"
                                       @change="fileChosen"/>
                                <div v-for="photos in chunkedPhotos" :key="photos.id">
                                    <div class="row image-row">
                                        <div v-for="photo in photos" :key="photo.id" class="col-3">
                                            <a href="javascript:void(0)">
                                                <div class="image">
                                                <img :src="photo.oURL" :id="photo.name" class="thumbnail img img-responsive full-width"
                                                     @click="showModal(photo.id)">
                                                </div>
                                            </a>
                                            <b-modal :id="getValidID(photo.id)" :ref="getValidID(photo.id)"
                                                     :title="photo.name" size="lg" :hide-footer=true>
                                                <b-img fluid :src="photo.oURL" :id="getValidID(photo.name)"></b-img>
                                                <div class="spacer"></div>
                                                <div class="trash-icon">
                                                    <a href="javascript:void(0)" @click="deletePhoto(photo.id)">
                                                        <icon name="trash-o"></icon>
                                                    </a>
                                                </div>
                                            </b-modal>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="add-link">
                                    <a href="javascript:void(0)" @click="openInput('photo')">
                                        {{$t('photos.addPhotoButton')}}
                                    </a>
                                    <span class="popover-trigger"
                                          v-b-popover.hover="$t('photos.popover')">
                                        <icon name="info-circle"></icon>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-12">
                    <card-title-component :title="$t('videos.title')"></card-title-component>
                    <div class="card-content">
                        <div class="row">
                            <div class="col">
                                <div class="add-link">
                                    <a href="javascript:void(0)" @click="openVideoInput('video')">
                                        {{$t('videos.addVideoButton')}}
                                    </a>
                                    <span class="popover-trigger"
                                          v-b-popover.hover="$t('videos.popover')">
                                        <icon name="info-circle"></icon>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col general-docs-item">
                                <input id="videoInput" ref="videoInput" type="file" style="visibility:hidden"
                                       accept="video/*"
                                       @change="videoChosen"/>
                                <div v-for="video in documents.videos" :key="video.id">
                                    <a href="javascript:void(0)" v-on:click="downloadVideo(video.id, video.name)">
                                        <icon name="film"></icon>
                                        {{video.name}}
                                    </a>
                                    <a href="javascript:void(0)" v-on:click="deleteVideo(video.id)">
                                        <icon name="trash-o"></icon>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row video-player-container" v-bind:class="{ 'player-is-not-shown': this.videoNotLoaded }">
                <div class="col">
                    <div class="embed-responsive embed-responsive-1by1">
                        <video controls id="video-player" muted="true">
                            <source src="">
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </div>
            </div>
        </b-form>
    </div>
</template>

<script>
    import chunk from 'chunk'
    import {mapActions, mapGetters, mapMutations} from 'vuex'
    import {
        DOCUMENTS_ACTION_DELETE_FILE,
        DOCUMENTS_ACTION_GET_DOCUMENTS,
        DOCUMENTS_ACTION_UPLOAD_FILE,
        DOCUMENTS_GETTER,
        DOCUMENTS_MUTATION_ENTIRE_DOCUMENTS,
        DOCUMENTS_NAMESPACE,
        DOCUMENTS_TYPE_PHOTO,
        DOCUMENTS_TYPE_VIDEO
    } from '../store/modules/documents-types'
    import TitleComponent from './shared/TitleComponent'
    import CardTitleComponent from './ui/card/CardTitleComponent'
    import FileUploadComponent from './funeral/FileUploadComponent'
    import i18n from '../assets/i18n/lang'
    import Icon from 'vue-awesome/components/Icon'
    import 'vue-awesome/icons/file-o'
    import 'vue-awesome/icons/info-circle'
    import 'vue-awesome/icons/film'
    import config from '../assets/data/siteconfig'
    import OAlert from '../utils/OAlert/OAlert'
    import API from '../services/API'

    const {detect} = require('detect-browser')

    export default {
        name: 'Photos',
        metaInfo () { return {title: i18n.t('photos.meta')} },
        components: {
            'title-component': TitleComponent,
            'card-title-component': CardTitleComponent,
            'file-upload-component': FileUploadComponent,
            'icon': Icon
        },
        data () {
            return {
                videoNotLoaded: true
            }
        },
        computed: {
            ...mapGetters(DOCUMENTS_NAMESPACE, {
                documents: DOCUMENTS_GETTER
            }),
            chunkedPhotos () {
                var image = document.createElement('app2e7659b9-e5e3-4bfe-903a-cff52000ef3b.jpg')
                image.onload = function () {
                    alert(image.width)
                }
                if (typeof this.documents.photos !== 'undefined') {
                    return chunk(this.documents.photos, 4)
                } else {
                    return []
                }
            }
        },
        methods: {
            ...mapMutations(DOCUMENTS_NAMESPACE, {
                updateDocuments: DOCUMENTS_MUTATION_ENTIRE_DOCUMENTS
            }),
            ...mapActions(DOCUMENTS_NAMESPACE, {
                loadDocuments: DOCUMENTS_ACTION_GET_DOCUMENTS,
                uploadFile: DOCUMENTS_ACTION_UPLOAD_FILE,
                deleteFile: DOCUMENTS_ACTION_DELETE_FILE
            }),
            openInput (type) {
                this.$refs.photoInput.click()
            },
            openVideoInput (type) {
                this.$refs.videoInput.click()
            },
            fileChosen (event) {
                let contentType = this.$refs.photoInput.files[0].type.replace('application/', '')
                contentType = contentType.replace('image/', '')
                if (config.validPhotoFileTypes.indexOf(contentType) > -1) {
                    this.uploadFile({
                        filename: this.$refs.photoInput.files[0].name,
                        file: this.$refs.photoInput.files[0],
                        type: DOCUMENTS_TYPE_PHOTO
                    })
                } else {
                    OAlert.showFailure('', i18n.t('feedback.filetypeFailUpload01') + contentType + i18n.t('feedback.filetypeFailUpload02'))
                }
            },
            videoChosen (event) {
                let contentType = this.$refs.videoInput.files[0].type.replace('application/', '')
                contentType = contentType.replace('image/', '')
                if (config.validVideoFileTypes.indexOf(contentType) > -1) {
                    this.uploadFile({
                        filename: this.$refs.videoInput.files[0].name,
                        file: this.$refs.videoInput.files[0],
                        type: DOCUMENTS_TYPE_VIDEO
                    })
                } else {
                    OAlert.showFailure('', i18n.t('feedback.filetypeFailUpload01') + contentType + i18n.t('feedback.filetypeFailUpload02'))
                }
            },
            downloadVideo (id, videoName) {
                API.downloadVideoFromBackend(id)
                    .then((data) => {
                        const browser = detect()
                        if (browser.os === 'iOS') {
                            return this.playVideo(data, videoName)
                        } else {
                            return this.insertDownloadlink(data, videoName)
                        }
                    })
                    .catch((error) => console.log('asdf' + error.message))
            },
            playVideo (data, docName) {
                return new Promise(
                    (resolve, reject) => {
                        window.URL = window.URL || window.webkitURL
                        var video = document.getElementById('video-player')
                        video.src = window.URL.createObjectURL(new Blob([data], {type: data.type}))
                        video.load()
                        this.videoNotLoaded = false
                        resolve()
                    }
                )
            },
            insertDownloadlink (data, docName) {
                return new Promise(
                    (resolve, reject) => {
                        window.URL = window.URL || window.webkitURL
                        const link = document.createElement('a')
                        link.href = window.URL.createObjectURL(new Blob([data], {type: data.type}))
                        link.setAttribute('download', docName)
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link)
                        resolve()
                    }
                )
            },
            getValidID (id) {
                return 'id' + id
            },
            showModal (id) {
                this.$root.$emit('bv::show::modal', this.getValidID(id))
            },
            deletePhoto (id) {
                this.deleteFile({
                    id: id,
                    type: DOCUMENTS_TYPE_PHOTO
                })
            },
            deleteVideo (id) {
                this.deleteFile({
                    id: id,
                    type: DOCUMENTS_TYPE_VIDEO
                })
            }
        },
        created () {
            this.loadDocuments()
        }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/scss/custom/vars';

    .button-div {
        text-align: right;
    }

    .image {
        position: relative;
        overflow: hidden;
        padding-bottom: 100%;
    }

    .image img {
        position: absolute;
        max-width: 100%;
        max-height: 100%;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
    }

    .image-row {
        padding-bottom: 20px;
    }

    .add-link {
        padding-top: 40px;
        text-align: right;
        /*text-decoration: underline;*/
    }

    .general-docs-item {
        text-align: left;
    }

    span.popover-trigger {
        text-decoration: none;
    }

    .spacer {
        padding: 20px;
    }

    .trash-icon {
        color: $omyfu-red;
        text-align: right;
        padding-right: 20px;
        /*text-decoration: underline;*/
    }

    .video-player-container {
        padding-top: 20px;
    }

    .player-is-not-shown {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/PhotosComponent.vue